// import { Message } from 'element-ui'
import store from '@/store'
export default {
  // duration: 2000,
  // setDuration (time) {
  //   this.duration = time
  // },
  // info (msg) {
  //   Message({
  //     message: msg,
  //     duration: this.duration
  //   })
  // },
  // success (msg) {
  //   Message({
  //     message: msg,
  //     type: 'success',
  //     duration: this.duration
  //   })
  // },
  // warn (msg) {
  //   Message({
  //     message: msg,
  //     type: 'warning',
  //     duration: this.duration
  //   })
  // },
  // err (msg) {
  //   Message({
  //     message: msg,
  //     type: 'error',
  //     duration: this.duration
  //   })
  // }
  info(msg) {
    store.dispatch('SetMessageOption', { contents: msg, color: 'info' })
    store.dispatch('SetShowMessage', true)
  },
  success (msg) {
    store.dispatch('SetMessageOption', { contents: msg, color: 'success' })
    store.dispatch('SetShowMessage', true)
  },
  warn (msg) {
    store.dispatch('SetMessageOption', { contents: msg, color: 'warning' })
    store.dispatch('SetShowMessage', true)
  },
  err (msg) {
    store.dispatch('SetMessageOption', { contents: msg, color: 'error' })
    store.dispatch('SetShowMessage', true)
  }

}
